const state = {
  postulante_data: [],
  data_created_modified: null,
};
export default state;
